module.exports = __webpack_public_path__ + "media/src/img/going_up-b86a88f9c1079ada5ad05df54edd91e5fa6659769931364f52c212df92039218.svg";